var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-detailed-list"},[_c('contact-top',{attrs:{"contactid":_vm.contactid,"contact-name":_vm.name},on:{"setContactName":_vm.setContactName}}),_c('contact-table',{attrs:{"contactid":_vm.contactid,"get-contact-name":_vm.getContactName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }